import { render, staticRenderFns } from "./handShake.vue?vue&type=template&id=c6301f64&scoped=true&"
import script from "./handShake.vue?vue&type=script&lang=js&"
export * from "./handShake.vue?vue&type=script&lang=js&"
import style0 from "./handShake.vue?vue&type=style&index=0&id=c6301f64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6301f64",
  null
  
)

export default component.exports